export default class Pairing {
    public static cantor = (x: number, y: number):number => ((x + y) * (x + y + 1)) / 2 + y;
    public static reverseCantor = (z: number):[number, number] => {
        const t = Math.floor((Math.sqrt(8 * z + 1) - 1)/2);
        return [t * (t + 3) / 2 - z, z - t * (t + 1) / 2];
    }
}